import React from 'react';
import './VenueAnalysisGrid.scss';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import classNames from 'classnames';
import Tooltip, { TooltipText } from 'utils/components/Tooltip/Tooltip';

export interface VenueAnalysisToggleLabelProps {
    name: string;
    showVenues: boolean;
    disabled?: boolean;
    onClick: () => void;
    tooltip: TooltipText;
}

export function VenueAnalysisToggleLabel({
    name,
    showVenues,
    disabled,
    onClick,
    tooltip,
}: VenueAnalysisToggleLabelProps) {
    const setClick = () => {
        if (!disabled) onClick();
    };

    return (
        <div className="VenueAnalysisToggleLabel">
            <div
                className={classNames('toggle-venues', disabled && 'disabled')}
                onClick={setClick}
            >
                {showVenues ? (
                    <Icon name="angle down" />
                ) : (
                    <Icon name="angle right" />
                )}
                <Tooltip text={tooltip}>
                    <div className="venue-bar-label">{name}</div>
                </Tooltip>
            </div>
            {showVenues && !disabled && (
                <div className="venue-label">Venue</div>
            )}
        </div>
    );
}
